import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/8c3dc8994f71a85ad2d71f226c89cc7edce114857865647a461869cb9a6c120ffe2f6c628544606d61dcf48135de6ac8/images/aW1hZ2UvcG5n/982cd76f140479f64830f15898823d30.png";

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Refined Minimal Header */}
      <header className="w-full py-6 md:py-8 px-6 flex justify-center items-center bg-brand-ivory">
        <Link to="/" className="block">
          <img 
            src={LOGO_URL} 
            alt="Padua Weddings" 
            className="h-20 md:h-28 w-auto object-contain transition-transform duration-700 hover:scale-[1.02]" 
          />
        </Link>
      </header>

      <main className="flex-grow">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="w-full py-16 px-6 md:px-12 border-t border-brand-espresso/5 bg-brand-ivory">
        <div className="max-w-6xl mx-auto flex flex-col items-center gap-8">
          <Link to="/" className="block">
            <img 
              src={LOGO_URL} 
              alt="Padua Weddings" 
              className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" 
            />
          </Link>
          <div className="flex flex-col items-center text-center gap-4">
            <p className="text-[10px] font-sans text-brand-espresso/40 tracking-[0.3em] uppercase">
              Historic Spanish Revival Venue &bull; Claremont, CA
            </p>
            <p className="text-[9px] font-sans text-brand-espresso/30 tracking-widest uppercase">
              © {new Date().getFullYear()} Padua Weddings. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;